import { Reducer } from "redux";
import baseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import UserActions from "../actions/userActions";
import UserModel from "../models/UserModel";


export interface IState {
    checkUserInitialSetup?: UserModel;
}
const initialState: IState = {
    checkUserInitialSetup: undefined,
};

export const checkUserInitialSetUp: Reducer = baseReducer(initialState, {
    [UserActions.REQUEST_CHECK_USER_INITIAL_SETUP_FINISHED]: (state: IState, action: IAction<UserModel>): IState => {
      return {
        ...state,
        checkUserInitialSetup: action.payload!
      };
    }
});